namespace $ {

	type $shm_wire_latest_state = {
		key: unknown
		value: unknown
	}

	const $shm_wire_latest_cache = new WeakMap< object, $shm_wire_latest_state >

	/**
	 * Keeps the latest successful value while the same resource is reloading.
	 * Suspends normally when there is no previous value or the resource key changed.
	 */
	export function $shm_wire_latest< Value >(
		key: unknown,
		task: ()=> Value,
	): Value {

		const fiber = $mol_wire_auto()

		return $mol_error_fence(
			()=> {
				const value = task()
				if( fiber ) $shm_wire_latest_cache.set( fiber, { key, value } )
				return value
			},
			error => {
				if( fiber ) $shm_wire_latest_cache.delete( fiber )
				return $mol_fail_hidden( error )
			},
			loading => {
				const previous = fiber ? $shm_wire_latest_cache.get( fiber ) : undefined
				if( previous && $mol_compare_deep( previous.key, key ) ) return previous.value as Value
				return $mol_fail_hidden( loading )
			},
		)
	}

}
